export * from "./ToteBetsApiBetRequest";
//# sourceMappingURL=index.js.map